import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'primeng/api';
import { SelectItem } from "primeng/components/common/selectitem";
import { CreateProgramModel } from "../../../../models/inModels/program";
import { AuthenticationService } from "../../../../services/authentication/authentication.service";
import { ProgramService } from "../../../../services/program.service";

@Component({
	selector: 'app-programs-create',
	templateUrl: './programs-create.component.html',
	styleUrls: ['./programs-create.component.css']
})
export class ProgramsCreateComponent implements OnInit {
	model: CreateProgramModel;
	loading = false;
	error: Message[];
	messages: Message[];
	types: SelectItem[];
	selectedType: SelectItem;
	constructor(
		private auth: AuthenticationService,
		private router: Router,
		private service: ProgramService) {
		this.model = new CreateProgramModel();
	}

	ngOnInit() {

	}

	initDropDown(event) {
		this.service.getDropdown(event).then(
			x => {
				this.types = x;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setType(): void {
		this.model.TypeId = this.selectedType.value;
	}

	goBack(): void {
		this.router.navigate(['/programs']);
	}

	save() {
		this.loading = true;
		this.service.create(this.model).then(
			result => {
				this.loading = false;
				this.router.navigate(['/programs']);
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/reporting/programs/programs-create/programs-create.component.ts